
import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import TelefonNumarasi from "@/components/inputs/TelefonNumarasi.vue";
import TakipDurumuPicker from "@/components/pickers/TakipDurumuPicker.vue";
import IcraDairesiPicker from "@/components/pickers/IcraDairesiPicker.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import KararNumarasi from "@/components/inputs/KararNumarasi.vue";
import TakipTipiPicker from "@/components/pickers/TakipTipiPicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import TakipEtiketiPicker from "@/components/pickers/TakipEtiketiPicker.vue";

@Component({
  components: {
    TakipEtiketiPicker,
    TakipTipiPicker,
    KararNumarasi,
    TcKimlikNumarasi,
    VergiNumarasi,
    IcraDairesiPicker,
    TakipDurumuPicker,
    TelefonNumarasi,
    DosyaEsasNumarasi
  }
})
export default class TakipListFilterForm extends Mixins(SimpleInputMixin) {
  // Tanımlı takip ek-alan türleri (dinamik filtre alanları için)
  ekAlanTurleri: Array<{ id: number; kod: string; isim: string }> = [];

  filters: any = {
    borcluAdSoyad: null,
    borcluTcKimlik: null,
    alacakliTcKimlik: null,
    borcluVergiKimlik: null,
    alacakliVergiKimlik: null,
    icraDairesi: null,
    dosyaEsasNo: null,
    alacakliAdSoyad: null,
    takipDurumu: null,
    ilamEsasNo: null,
    ilamKararNo: null,
    kartNo: null,
    icraProKartNo: null,
    mtsEsasNo: null,
    tuketiciKodu: null,
    kurumDosyaNo: null,
    takipTipiNo: null,
    keyword: null,
    ekAlanlar: {}
  };

  mounted() {
    // localValue ek-alan objesi yoksa başlat (reaktif)
    if (this.localValue && !this.localValue.ekAlanlar) {
      Vue.set(this.localValue, 'ekAlanlar', {});
    }
    this.loadEkAlanTurleri();
  }

  loadEkAlanTurleri() {
    this.$http.get('/api/v1/takip-ek-alan-turu').then((response: any) => {
      this.ekAlanTurleri = (response.data || []).map((t: any) => ({
        id: t.id,
        kod: t.kod,
        isim: t.isim
      }));
    }).catch(() => {
      this.ekAlanTurleri = [];
    });
  }

  onEkAlanInput(kod: string, value: string) {
    if (!this.localValue.ekAlanlar) {
      Vue.set(this.localValue, 'ekAlanlar', {});
    }
    if (value === '' || value === null || value === undefined) {
      Vue.delete(this.localValue.ekAlanlar, kod);
    } else {
      Vue.set(this.localValue.ekAlanlar, kod, value);
    }
    this.input();
  }

  restrictInput(event: any) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];
    const isNumeric = /^[0-9]$/;

    if (allowedKeys.includes(event.key)) return;

    if (!isNumeric.test(event.key)) {
      event.preventDefault();
    }
  }

  sifirla() {
    this.localValue = {...this.filters, ekAlanlar: {}};
    this.input();
    this.$emit('search');
  }
}
